module.exports = __webpack_public_path__ + "img/customer7.950117ce.png";